import axios from 'axios';

// Get token from local storage
const getToken = () => {
    return localStorage.getItem('token');
};

// 如果本地代理不生效，可以直接在这里配置远程服务器地址
// const SERVER_DOMAIN = 'https://lundbeck-kol360-mobile-dev.lekinsights.cn';
const SERVER_DOMAIN = import.meta.env.VITE_SERVER_ORIGIN || '';

// Create an axios instance
const service = axios.create({
    baseURL: SERVER_DOMAIN,
    timeout: 60000 // Request timeout
});

// Request interceptor
service.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// Response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data;
        // Adjust this check based on your actual API response structure
        // The original code passed through the response, so we might just return res.
        // Or if the original code expected the full response object for headers, etc.
        // Looking at ai.js, it expects `res.value` or `res['@odata.count']`.
        // So returning response.data is likely correct if axios automatically parses JSON.
        return res;
    },
    error => {
        console.log('err' + error); // for debug
        return Promise.reject(error);
    }
);

// 获取聊天记录
export const getChatHistory = (chatId: string) => {
    return service({
        url: `/api/standard/odata/UserCopilotChatHistories?$filter=user_copilot_chat_id eq '${chatId}'&$orderby=chat_time asc`,
        method: 'get'
    });
};

// 获取用户的会话列表 (支持分页)
export const getChatSessions = (userId: string, pageNum = 1, pageSize = 10) => {
    const skip = (pageNum - 1) * pageSize;
    return service({
        url: `/api/standard/odata/UserCopilotChats?$filter=user_id eq '${userId}'&$orderby=chat_time desc&$skip=${skip}&$top=${pageSize}&$count=true`,
        method: 'get'
    });
};

// 保存会话Session
export const saveChatSession = (data: any) => {
    const payload = {
        session_id: data.session_id,
        user_id: data.user_id,
        chat_title: data.chat_title,
        chat_time: data.chat_time
    };
    return service({
        url: '/api/standard/odata/UserCopilotChats',
        method: 'post',
        data: payload
    });
};

// 删除会话Session
export const deleteChatSession = (id: string) => {
    return service({
        url: `/api/standard/odata/UserCopilotChats('${id}')`,
        method: 'delete'
    });
};

// 保存聊天记录
export const saveChatHistory = (data: any) => {
    const payload = {
        user_copilot_chat_id: data.user_copilot_chat_id,
        session_id: data.session_id,
        user_id: data.user_id,
        chat_role: data.chat_role,
        content: data.content,
        chat_time: data.chat_time
    };
    return service({
        url: '/api/standard/odata/UserCopilotChatHistories',
        method: 'post',
        data: payload
    });
};

// Stream helper
const streamBailianRequest = async (apiName: string, payload: any, callbacks: any) => {
    const { onChunk, onComplete, onError } = callbacks;

    // 与其他 custom 接口保持一致，走相对路径并复用当前登录态 token
    const url = `/api/ai/Bailian/Agent/${apiName}`;

    try {
        const token = getToken();
        // @ts-ignore
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : '',
                'Cache-Control': 'no-cache'
            },
            body: JSON.stringify({
                ...payload,
                incremental_output: true,
                sse: true
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        if (!response.body) throw new Error('Response body is null');

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        // Buffer to accumulate data from chunks
        let buffer = '';
        
        // eslint-disable-next-line no-constant-condition
        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            const chunk = decoder.decode(value, { stream: true });
            buffer += chunk;
            
            // Process lines in buffer
            let newlineIndex;
            while ((newlineIndex = buffer.indexOf('\n')) >= 0) {
                const line = buffer.slice(0, newlineIndex).trim();
                buffer = buffer.slice(newlineIndex + 1);
                
                if (line.startsWith('data:')) {
                    const dataStr = line.slice(5).trim();
                    if (dataStr === '[DONE]') continue;
                    
                    try {
                        const data = JSON.parse(dataStr);
                        // Extract text from output.text
                        // Since incremental_output: true, this should be the delta
                        const text = data?.output?.text || '';
                        if (text && onChunk) {
                            onChunk(text);
                        }
                    } catch (e) {
                        // ignore parse errors for non-json lines
                    }
                }
            }
        }

        if (onComplete) onComplete();
    } catch (error) {
        if (onError) onError(error);
    }
};

export const streamSuperRepCopilot = ({ content, sessionId, onChunk, onComplete, onError }: any) => {
    const payload = {
        content,
        session_id: sessionId || null
    };
    return streamBailianRequest('MeetingCopilot', payload, { onChunk, onComplete, onError });
};
